(function () {
  const filtersContainer = document.querySelector("#docs-container");
  if (!filtersContainer) {
    // Return if we are not in the documentation page.
    return;
  }

  const searchBox = document.querySelector("#search-box");
  searchBox.addEventListener("input", function () {
    const searchQuery = searchBox.value.toLowerCase();
    const container = document.querySelector("#docs-container .cards");
    filterElements(container, searchQuery);
  });

  /**
   * Filters elements that do not include the specified filter text.
   *
   * @param {HTMLElement} container - The container element that holds the div elements to be filtered.
   * @param {string} filterText - The text used for filtering the div elements.
   */
  function filterElements(container, filterText) {
    const elements = Array.from(container.children);
    elements.forEach((div) => {
      if (filterText.length === 0 || div.textContent.toLowerCase().includes(filterText.toLowerCase())) {
        div.style.display = "";
      } else {
        div.style.display = "none";
      }
    });
  }

  const token = Cookies.get("TOKEN");
  if (token) {
    fetch("https://dashboard.accounts.developer.siemens.com/proxy/api/credentials/v1/user/credentials", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const userCredentials = data.filter((p) => p.revoked == false && (p.validUntil == null || new Date(p.validUntil).getTime() >= new Date().getTime()));

        const listItems = document.querySelectorAll(".card");

        listItems.forEach((card) => {
          if (userCredentials.some((p) => p.packageName.includes(card.dataset.packageName))) {
            card.dataset.accessAvailable = "true";
          }
        });

        const cardsContainer = document.querySelector(".cards");
        const sortedItems = Array.from(listItems).sort((a, b) => {
          if (a.dataset.accessAvailable && !b.dataset.accessAvailable) {
            return -1;
          } else {
            return 1;
          }
        });
        sortedItems.forEach((item) => {
          cardsContainer.appendChild(item);
        });
      });
  }
})();
